import { useNavigate } from 'react-router-dom';

import { ScheduleTemplateResp } from '@api/responseModels/worker/schedule/scheduleTemplateResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TScheduleTemplate } from '../common/types';
import { TState } from '../schedule';

export function useUpdateTemplate({
    crmID,
    state,
    validateSchedule,
    workerPositionID,
    wpMode,
    messageApi,
    isTemplateNameChanged,
}: {
    state: TState;
    crmID: number | string;
    workerPositionID: number | string;
    validateSchedule: () => boolean;
    wpMode: boolean;
    messageApi: any;
    isTemplateNameChanged: boolean;
}) {
    const navigate = useNavigate();

    const updateTemplate = async () => {
        if (!validateSchedule()) return;
        state.isLoading = true;

        try {
            const ts = state.schedule as TScheduleTemplate;

            const result = await CRMAPIManager.request<ScheduleTemplateResp>(async (api) => {
                return await api.updateScheduleTemplate({
                    ...ts,
                    title: isTemplateNameChanged ? ts.title : undefined,
                });
            });

            if (result.errorCode) throw result;

            messageApi.success('Шаблон обновлён');

            if (wpMode) {
                navigate(`/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`);
            } else {
                navigate(`/lk/worker/crm/${crmID}/schedule`);
            }
        } catch (err) {
            messageApi.error('Ошибка при обновлении шаблона');
            console.log(err);
        }

        state.isLoading = false;
    };

    return { updateTemplate };
}
